export const FullNameAutocompleteTexts = {
  wrongCharset: 'Переключите раскладку клавиатуры на кириллицу',
};
